import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import Storage from "vue-ls";

Vue.config.productionTip = false;

let options = {
  namespace: "vuejs__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
  iconfont: "mdi",
};

Vue.use(Storage, options);

import VueToast from "vue-toast-notification";
// Import any of available themes
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast, {
  position: "top-right",
  duration: 4000,
});

// ================
// Vue-stash store
// ----------------
import VueStash from "vue-stash";
import store from "./store";
import vuetify from "./plugins/vuetify";
Vue.use(VueStash);

// ================
// Vuelidate
// ----------------
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// ================
// Vue-moment
// ----------------
import VueMoment from "vue-moment";
import moment from "moment-timezone";

// ================
// VueChatScroll
// ----------------
import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);
// ================
// Lodash
// ----------------
import VueLodash from "vue-lodash";
import lodash from "lodash";

// name is optional
Vue.use(VueLodash, { name: "custom", lodash: lodash });

Vue.use(VueMoment, {
  moment,
});
const vm = new Vue({
  router,
  i18n,
  data: { store },
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export default vm;
